/**
 * Política de reintento de las queries de TanStack Query.
 *
 * `defaultQueryRetry` es la política global del `QueryClient` (`main.tsx`).
 * Vive aquí para que las queries que la ajustan la compongan en vez de
 * copiarla: una copia divergiría en cuanto cambie la global.
 */

import { ApiError, isForbiddenTier, isTenantStateDenial, platformAccessDenial } from './client'

/** Un reintento, salvo 401 (redirige a login) y los rechazos por estado de la
 *  organización (`TENANT_READ_ONLY`/`TENANT_SUSPENDED`, que refrescan `/me`):
 *  los dos los maneja `handleApiError` en `main.tsx` y reintentar no cambia
 *  la respuesta. */
export function defaultQueryRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status === 401) return false
  if (isTenantStateDenial(error)) return false
  return failureCount < 1
}

/**
 * Para las lecturas de recursos internos del tenant (OT-0015): un
 * `403 FORBIDDEN_TIER` no se reintenta; cualquier otro error sigue la
 * política global.
 */
export function retryUnlessForbiddenTier(failureCount: number, error: unknown): boolean {
  if (isForbiddenTier(error)) return false
  return defaultQueryRetry(failureCount, error)
}

/**
 * Para la plataforma (OT-0073): `PLATFORM_MFA_REQUIRED` y
 * `PLATFORM_OPERATOR_REQUIRED` no se reintentan; cualquier otro error sigue
 * la política global.
 */
export function retryUnlessPlatformDenied(failureCount: number, error: unknown): boolean {
  if (platformAccessDenial(error)) return false
  return defaultQueryRetry(failureCount, error)
}
